import { render } from "./HomeView.vue?vue&type=template&id=5c4bdb15"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/harry/Desktop/Vue JS/Matrix Digital/Alearif zain portal/alearif-zain/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__